import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { TextAreaItem } from "../../../components/forms/FormItems";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { SelectItem as SelectItemComponent } from "../../../components/forms/FormItems";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { useSelector } from "react-redux";
const Summary = (props) => {
  const {
    activeHouseVisit,
    changedValues,
    approved,
    enabled,
    futureVisit,
    employees,
  } = props;
  const [plannedIsController, setPlannedIsController] = useState(null);
  const [userIsProOrAdmin, setUserIsProOrAdmin] = useState(null);
  const profile = useSelector((state) => state.user.profile);

  useEffect(() => {
    const employeeId =
      changedValues.planned_employee_id || activeHouseVisit.planned_employee_id;

    const filteredFormEmployee =
      employees.length > 0 && employees.filter((i) => i.id === +employeeId)[0];
    if (filteredFormEmployee) {
      setPlannedIsController(filteredFormEmployee.professional_role_id === 3);
    }
    const filteredUserEmployee =
      employees.length > 0 &&
      profile.associated_employee_id &&
      employees.filter((i) => i.id === profile.associated_employee_id)[0];
    const isPro =
      filteredUserEmployee &&
      filteredUserEmployee.professional_role_id &&
      filteredUserEmployee.professional_role_id !== 3;
    if (isPro || profile.admin) {
      setUserIsProOrAdmin(true);
    }
  }, [employees, activeHouseVisit, changedValues, profile]);

  const isApproved =
    changedValues.approved !== undefined
      ? changedValues.approved
      : activeHouseVisit.approved;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.summary" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <TextAreaItem
                  name="report.summary_and_recommendations"
                  rows={2}
                  category="house_visits"
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ display: "flex", flex: 1 }}>
                <div style={{ display: "flex", flex: 1 }}>
                  <RadioButtonItem
                    name="approved"
                    category="house_visits"
                    trueFalse={true}
                    disabled={!enabled || futureVisit}
                  />
                </div>
                <Spacer horizontal={true} />
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 2 }}>
                  {isApproved === false && (
                    <div style={{ width: "100%" }}>
                      <SelectItemComponent
                        name="reason_not_approved"
                        category="house_visits"
                        reasonNotApproved={true}
                        disabled={!enabled}
                      />
                    </div>
                  )}
                </div>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
                <div style={{ display: "flex", flex: 1 }} />
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <RadioButtonItem
                    name="verified"
                    category="house_visits"
                    trueFalse={true}
                    disabled={
                      (activeHouseVisit.verified &&
                        !activeHouseVisit.can_unverify) ||
                      futureVisit
                    }
                  />
                </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default Summary;
